"use client"

import { useQuery } from "@tanstack/react-query"

import type { VoiceAgent } from "@/hooks/agents/voice/use-agents"
import { useAuth } from "@/hooks/use-auth"

export const voiceAgentQueryKey = (agentId: string) => [
  "voice-agent",
  agentId,
] as const

export function useVoiceAgentQuery(agentId: string | null) {
  const { fetchWithAuth } = useAuth()

  return useQuery<VoiceAgent>({
    queryKey: voiceAgentQueryKey(agentId ?? "none"),
    enabled: Boolean(agentId),
    queryFn: async () => {
      if (!agentId) throw new Error("Phone Voice Agent id is required.")
      const response = await fetchWithAuth(`/api/agents/voice/${agentId}`)
      const result = (await response.json()) as {
        agent?: VoiceAgent
        error?: string
      }
      if (!response.ok || !result.agent) {
        throw new Error(result.error ?? "Failed to load Phone Voice Agent.")
      }
      return result.agent
    },
  })
}
